//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uiBottom from '@/component/uiBottom'
import uiCode from './uiCode'
import { getQueryVariable } from '../../util/const'
import { setAuthorization } from '../../axios/userInfo'
import { getUserInfo, isApp } from '@/util/const'

export default {
  components: {
    uiBottom,
    uiCode
  },
  data () {
    return {
      code: {},
      redeem_passcode: null
    }
  },
  created () {
    window.getUserInfo = (obj) => {
      if (obj) {
        setAuthorization(obj.authorization)
        let param = {
          type: 'TICKET',
          subtype: 'HANA_CONCERT',
          msisdn: getQueryVariable('msisdn'),
          customer_id: getQueryVariable('customer_id'),
          reward_code: getQueryVariable('reward_code'),
          redeem_passcode: this.redeem_passcode
        }
        this.$http.post(`/v1/api/user/hanaConcert/redeem`, { body: param }).then(res => {
          if (res.data.body.result === 0) {
            location.href = 'openpage://50300'
          } else if (res.data.body.result === -1) {
            this.$toast({ msg: this.$t('concert.concert37'), time: 1000 })
          } else if (res.data.body.result === -3) {
            this.$toast({ msg: this.$t('concert.concert37'), time: 1000 })
          } else {
            this.$router.replace({ path: '/invalidPage' })
          }
        })
      }
    }
  },
  methods: {
    jump (code) {
      this.redeem_passcode = code
      if (isApp()) {
        getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
      } else {
        let param = {
          type: 'TICKET',
          subtype: 'HANA_CONCERT',
          msisdn: getQueryVariable('msisdn'),
          customer_id: getQueryVariable('customer_id'),
          reward_code: getQueryVariable('reward_code'),
          redeem_passcode: this.redeem_passcode
        }
        setAuthorization('20a1429c-13f5-4f0b-9895-fdf881351d76')
        this.$http.post(`/v1/api/user/hanaConcert/redeem`, { body: param }).then(res => {
          if (res.data.body.result === 0) {
            location.href = 'openpage://50300'
          } else if (res.data.body.result === -1) {
            this.$toast({ msg: this.$t('concert.concert37'), time: 1000 })
          } else if (res.data.body.result === -3) {
            this.$toast({ msg: this.$t('concert.concert37'), time: 1000 })
          } else {
            this.$router.replace({ path: '/invalidPage' })
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/signConfirm.vue